import { useQuery } from "react-query";
import { fetchMarketSection } from "./fetchMarketSection";

const useRecommendedLimit = () => {
  const { data, isLoading, isError } = useQuery("recommendedLimit", async () => {
    const result = await fetchMarketSection(
      `${process.env.REACT_APP_SERVER_URL}/product/all-products`
    );
    return result || { products: [] };
  });

  return { data, isLoading, isError };
};

export default useRecommendedLimit;
